<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="748">
    <div class="px-12 pt-9 pb-7 white">
      <v-row class="pb-12">
        <v-col cols="12">
          <p
            class="primary--text font-weight-bold mb-2 modal-details-insurance__title"
          >
            SEGURADORA DECLINADA!
          </p>
          <p class="primary--text font-weight-medium mb-8">
            A seguradora declinou. Veja o motivo:
          </p>
        </v-col>
        <v-col cols="12" class="modal-details-insurance__content pa-2">
          <div
            v-html="item.minuta_declinada.comentario_declinio"
            class="mb-0 primary--text modal-details-insurance__div"
          />
        </v-col>
        <v-col cols="12" class="pt-5">
          <v-row>
            <v-col
              cols="auto"
              v-for="(element, key) in item.minuta_declinada.anexos_declinio"
              :key="key"
              class="modal-details-insurance__file px-4 py-2 mr-5 mb-5 mb-sm-0"
            >
              <div
                class="d-flex align-center gray--text body-2"
                @click="previewFile(element)"
              >
                <v-icon class="pr-3" color="primary">
                  fa-file
                </v-icon>
                {{ element.nome }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="6" sm="3">
          <BaseButton
            v-html="'OK'"
            class="secondary"
            width="100%"
            @click="closeModal"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
import DocumentsMixin from "@/mixins/DocumentsMixin";
export default {
  mixins: [DocumentsMixin],
  methods: {
    closeModal() {
      this.$emit("close");
    },
    previewFile(item) {
      window.open(item.url);
    }
  },
  props: {
    item: {
      type: Object
    }
  }
};
</script>
<style lang="sass">
.modal-details-insurance__
  &title
    font-size: 20px
  &content
    border: 1px solid #D5D5E0
    border-radius: 2px
    background-color: #FFFFFF
  &file
    border: 1px solid #D5D5E0
    border-radius: 4px
    background-color: #FAFAFC
    cursor: pointer
    height: 42px
  &div
    p img
      width: 100% !important
</style>
